// extracted by mini-css-extract-plugin
export default {"Text":"TruncatedOptionLabel_Text__ZVThz","TooltipHost":"TruncatedOptionLabel_TooltipHost__jln-+"};